import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {
  NbIconLibraries,
  NbLayoutDirection,
  NbLayoutDirectionService,
  NbToggleStates,
} from '@nebular/theme';
import { Location } from '@angular/common';
import { ApplicationModule } from './core/common/appModule';
import { SettingsService } from './core/services/settings.service';
import { MENU_ITEMS } from './modules/pages-menu';
import { AuthService } from './core/auth/auth.service';
import { StrongFBHttpService } from './StrongFB/services/StrongFB-http.service';
import { StrongFBService } from './StrongFB/services/StrongFB.service';
import { environment } from 'src/environments/environment';
import { TransmitService } from './core/services/transmit.service';
import { WorkflowHttpService } from './common/services/Workflow-http.service';
import { AuthService as permissionsService } from './common/services/auth.service';
import {
  ActivatedRoute,
  NavigationEnd,
  ResolveEnd,
  Router,
  RoutesRecognized,
} from '@angular/router';
import { SidebarService } from './common/services/sidebar.service';
import { HttpService } from './core/services/http.service';
import { ProfileService } from './common/services/profile.service';
import { CookieService } from './common/services/Cookie.service';
import { EnvironmentService } from './core/services/environment.service';
import { ActiveRouteProperty } from './core/common/types';
import { checkAndDoByInterval } from './StrongFB/common/StrongFB-common';
import { Subject, takeUntil } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { HEADER_ITEMS } from './modules/header-menu';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  menu = MENU_ITEMS;
  headerMenu = HEADER_ITEMS;
  menuMode: 'expanded' | 'collapsed' | 'compacted' = 'expanded';
  @ViewChild('serviceRef', { read: ViewContainerRef })
  ServiceRef: ViewContainerRef;
  bootLoading = true;
  currentLocation = '';
  buildNumber = environment.buildNumber;
  toggleState: NbToggleStates = NbToggleStates.Expanded;
  userPermissions: string[];

  forceAuthenticate = true;
  showSidebar = false;
  showTopBar = true;
  showFooter = false;
  menuPreLoad: boolean = false;
  noPaddingPage: boolean = false;
  notifier = new Subject<void>();
  protected destroy$ = new Subject<void>();
  isMobileSize: boolean = false;

  constructor(
    private _layoutService: NbLayoutDirectionService,
    private location: Location,
    public authService: AuthService,
    private _iconLibraries: NbIconLibraries,
    private _http: StrongFBHttpService,
    private srv: StrongFBService,
    private _workflowHttpService: WorkflowHttpService,
    private transmit: TransmitService,
    public _router: Router,
    private _permissionService: permissionsService,
    private _sidebarService: SidebarService,
    private http: HttpService,
    private _profileService: ProfileService,
    private _title: Title,
    private meta: Meta,
    private _cookieService: CookieService,
    private _enviromentSevice: EnvironmentService,
    private breakpointObserver: BreakpointObserver,
    public _activatedRoute: ActivatedRoute
  ) {
    const orginalRedirect = _router.navigateByUrl.bind(_router);
    const orginalBack = location.back.bind(location);
    //proxy to monitor routes
    location.back = () => {
      console.log('back');
      if (!window['ameh']) {
        return;
      }
      return orginalBack();
    };
    _router.navigateByUrl = (url, extra) => {
      return orginalRedirect(url, extra);
    };
    this._iconLibraries.registerFontPack('fontawesome', {
      ligature: true,
      packClass: 'fontawesome',
    });
    this._iconLibraries.setDefaultPack('fontawesome');
  }
  async ngOnInit(): Promise<void> {
    // =>set default for sidebar
    // const location = new URL(window.location.href).pathname;
    // if (location.startsWith('/auth/')) {
    //   this.showSidebar = false;
    //   this.showTopBar = false;
    // }

    this._router.events.pipe(takeUntil(this.notifier)).subscribe((event) => {
      // if (win.location.href.includes('/auth/login')) {
      //   this.showSidebar = false;
      //   this.showTopBar = false;
      // } else {
      //   this.showSidebar = true;
      //   this.showTopBar = true;
      // }
      // =>if end of navigation
      if (event instanceof NavigationEnd) {
        this._title.setTitle('دادگام');
        this.meta.updateTag({ name: 'description', content: 'دادگام' });
        this.setRouteProperties();
        this.noPaddingPage = false;
      }
    });

    this._layoutService.setDirection(NbLayoutDirection.RTL);
    // =>remove boot loader
    document.getElementById('_boot_global_loading_').style.display = 'none';
    this.bootLoading = false;
    this.setToggleState();
    // if (this.authService.isAuthenticated()) {
    //   await this._permissionService.updatePermissions()

    // }

    this.transmit.listen('no-pad').subscribe((it) => {
      if (!it) {
        this.noPaddingPage = false;
        return;
      }
      this.noPaddingPage = true;
    });

    this.transmit.listen('no-sideBar').subscribe((it) => {
      if (!it) return;
      this.showSidebar = false;
    });

    this.transmit.listen('has-sideBar').subscribe((it) => {
      if (!it) return;
      this.showSidebar = true;
    });

    this.transmit.listen('no-footer').subscribe((it) => {
      if (!it) return;
      this.showFooter = false;
    });

    this.setIsMobileSize();

    window.addEventListener('goftino_ready', () => {
      this.transmit.emit('goftino_ready', true);
    });
  }

  setRouteProperties() {
    let properties: ActiveRouteProperty[] = [];
    // =>get last child of route
    let targetRoute = this._getTargetActivatedRoute(this._activatedRoute);
    if (
      targetRoute.snapshot?.data &&
      targetRoute.snapshot?.data['properties'] &&
      Array.isArray(targetRoute.snapshot?.data['properties'])
    ) {
      properties = targetRoute.snapshot.data['properties'] as any;
    }
    // console.log('page props:', propertie s, environment.production, targetRoute);
    // =>check no authenticate property
    this.forceAuthenticate = !properties.includes('no-auth');
    // =>check no sidebar property
    this.showSidebar = !properties.includes('no-sidebar');
    // =>check no topbar property
    this.showTopBar = !properties.includes('no-topbar');
    // =>check has footer property
    this.showFooter = properties.includes('has-footer');
    // =>redirect to login page, if need authenticate
    if (
      environment.production &&
      !this.http.getToken() &&
      this.forceAuthenticate
    ) {
      console.log('here in the app compoennt');
      this._enviromentSevice.logout();
    }
    this.menuPreLoad = true;
  }

  private _getTargetActivatedRoute(activatedRoute: ActivatedRoute) {
    if (activatedRoute.children && activatedRoute.children.length > 0) {
      return this._getTargetActivatedRoute(activatedRoute.children[0]);
    }

    return activatedRoute;
  }

  setToggleState() {
    this._sidebarService.getSidebarState('menu-sidebar').subscribe((value) => {
      this.toggleState = value;
    });
  }

  ngAfterViewInit() {
    let ref = setInterval(() => {
      if (!this.ServiceRef) return;
      this.srv.config({
        viewContainerRef: this.ServiceRef,
        injectServices: {
          http: this.http,
          wfhttp: this._workflowHttpService,
          permissionsService: this._permissionService,
          environment: this._enviromentSevice,
        },
        apiEndPoint: environment.baseUrl,
        language: 'fa',
        authenticationHeaderName: 'Authorization',
        loginUrl: '/auth/login',
        fontFamily: 'IranSans',
        customFontPack: {
          name: 'fontawesome',
          type: 'font-awesome',
        },
      });
      clearInterval(ref);
    }, 10);
  }

  private setIsMobileSize(): void {
    this.breakpointObserver
      .observe(['(max-width: 1140px)'])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: BreakpointState) => {
        this.isMobileSize = result.matches;
      });
  }

  goToPage(link) {
    this._router.navigateByUrl(link);
  }
}
